var map = {
	"./account/account.module": [
		"./src/app/routes/account/account.module.ts",
		"account-account-module"
	],
	"./bill/bill.module": [
		"./src/app/routes/bill/bill.module.ts",
		"bill-bill-module"
	],
	"./cooperator/cooperator.module": [
		"./src/app/routes/cooperator/cooperator.module.ts",
		"cooperator-cooperator-module"
	],
	"./customer/customer.module": [
		"./src/app/routes/customer/customer.module.ts",
		"customer-customer-module"
	],
	"./exception/exception.module": [
		"./src/app/routes/exception/exception.module.ts",
		"exception-exception-module"
	],
	"./review/review.module": [
		"./src/app/routes/review/review.module.ts",
		"review-review-module"
	],
	"./stat/stat.module": [
		"./src/app/routes/stat/stat.module.ts",
		"stat-stat-module"
	],
	"./system/system.module": [
		"./src/app/routes/system/system.module.ts",
		"system-system-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;